import { useState } from 'react';
import { nextActivity, ORDER, type Activity } from '@/features/tongue-lab/lessons';
import { TongueLab } from '@/features/tongue-lab/TongueLab';

/** Development page (`?tonguelab`, optionally `&activity=watch|build|quiz|fix|drag|spin`): the Tongue Lab. */
export function TongueLabPreview() {
  const [activity] = useState<Activity>(() => {
    const asked = new URLSearchParams(window.location.search).get('activity');
    return ORDER.find((a) => a === asked) ?? nextActivity(localStorage);
  });
  const [log, setLog] = useState('');
  return (
    <main
      style={{
        padding: 16,
        background: '#0b1a3a',
        height: '100dvh',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      <p data-testid="activity" style={{ color: '#9fb3d9', margin: 0 }}>
        {activity} {log}
      </p>
      <div style={{ flex: 1, minHeight: 0, maxWidth: 900, width: '100%', margin: '0 auto' }}>
        <TongueLab
          activity={activity}
          onDone={(a, ok) => {
            setLog(`done: ${a} ${ok ? 'ok' : 'not yet'}`);
          }}
        />
      </div>
    </main>
  );
}
